module.exports = __webpack_public_path__ + "img/f6820a15e3daec66bef79d6422f3efab.b8b9d59d.png";